// ─── Watchlist of a registered user (sprint 13, 5.8) ────────────────────────
//
// One row per symbol, in public.watchlist (migrations/sprint13.sql · RLS: a
// user reads, adds and removes only their own rows). A guest's watchlist is
// the demo list in memory and is not written here.
//
// Until David runs the SQL the table does not exist: every call answers
// { unavailable: true } instead of throwing, and the screen says that saving
// is not available yet rather than pretending it saved.
import { supabase } from "./supabase";

const MISSING = new Set(["42P01", "PGRST205"]);   // relation / table not found
const answer = error => (error ? { error, unavailable: MISSING.has(error.code) } : null);

export async function loadWatchlist() {
  if (!supabase) return { rows: [], unavailable: true };
  const { data, error } = await supabase.from("watchlist").select("symbol, created_at").order("created_at");
  const bad = answer(error);
  if (bad) return { rows: [], ...bad };
  return { rows: (data || []).map(r => r.symbol) };
}

export async function addWatch(userId, symbol) {
  if (!supabase || !userId) return { unavailable: true };
  const { error } = await supabase.from("watchlist").insert({ user_id: userId, symbol });
  // 23505: already there · the list is what the user wanted, not an error.
  if (error && error.code === "23505") return {};
  return answer(error) || {};
}

export async function removeWatch(symbol) {
  if (!supabase) return { unavailable: true };
  const { error } = await supabase.from("watchlist").delete().eq("symbol", symbol);
  return answer(error) || {};
}
